import React, { useState, useEffect } from 'react';
import api from '../services/api';

export default function MijnVoorstellen() {
  const [lijst, setLijst] = useState([]);
  const [monteurs, setMonteurs] = useState([]);
  const [actief, setActief] = useState(null); // partij die behandeld wordt
  const [keuzeDatum, setKeuzeDatum] = useState('');
  const [keuzeMonteurs, setKeuzeMonteurs] = useState([]);
  const [busy, setBusy] = useState(false);

  const laad = async () => {
    try {
      const r = await api.get('/werkorder-partijen/mijn-voorstellen/lijst');
      setLijst(r.data.voorstellen || []);
      const g = await api.get('/gebruikers');
      setMonteurs((g.data.gebruikers || g.data || []).filter(x => x.actief && !String(x.gebruikersnaam || '').startsWith('oa_')));
    } catch (e) {}
  };
  useEffect(() => { laad(); }, []);

  const geefAkkoord = async () => {
    if (!keuzeDatum) { alert('Kies een datum'); return; }
    setBusy(true);
    try {
      const r = await api.post(`/werkorder-partijen/partijen/${actief.partij_id}/akkoord`, {
        gekozen_datum: keuzeDatum, monteur_ids: keuzeMonteurs
      });
      alert(r.data.message);
      setActief(null); setKeuzeDatum(''); setKeuzeMonteurs([]);
      laad();
    } catch (e) { alert(e.response?.data?.message || 'Fout bij akkoord'); }
    setBusy(false);
  };

  const fmtD = d => new Date(d).toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short' });

  return (
    <div style={{ padding: '24px', maxWidth: '900px', margin: '0 auto' }}>
      <h1>📥 Voorstellen voor mijn afdeling</h1>
      {lijst.length === 0 && <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', color: '#6b7280' }}>Geen openstaande voorstellen. 🎉</div>}
      {lijst.map(v => (
        <div key={v.partij_id} style={{ background: '#fff', borderRadius: '12px', padding: '18px', marginBottom: '14px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <div style={{ fontWeight: 700, fontSize: '16px' }}>{v.titel}</div>
              <div style={{ fontSize: '13px', color: '#6b7280', marginTop: '4px' }}>
                Order {v.ordernummer || '#' + v.werkorder_id} · {v.duur_dagen || 1} {(v.duur_dagen || 1) === 1 ? 'dag' : 'dagen'} · {v.dienst_type === 'nacht' ? '🌙 Nacht' : '☀️ Dag'}{v.aanvang_tijd ? ' · aanvang ' + v.aanvang_tijd : ''}{v.locatie_adres ? ' · ' + v.locatie_adres : ''}
              </div>
              <div style={{ fontSize: '13px', color: '#6b7280' }}>Aangevraagd door {v.aanvrager || 'onbekend'}</div>
              <div style={{ marginTop: '6px' }}>
                <a href={`/werkorders/${v.werkorder_id}`} style={{ fontSize: '13px', color: '#2563eb' }}>Bekijk werkorder →</a>
              </div>
            </div>
            <button onClick={() => { setActief(v); setKeuzeDatum(''); setKeuzeMonteurs([]); }}
              style={{ background: '#059669', color: '#fff', border: 'none', borderRadius: '8px', padding: '9px 16px', fontWeight: 600, cursor: 'pointer' }}>Behandelen</button>
          </div>

          {actief && actief.partij_id === v.partij_id && (
            <div style={{ background: '#f0fdf4', border: '1px solid #86efac', borderRadius: '10px', padding: '14px', marginTop: '12px' }}>
              <div style={{ fontSize: '13px', fontWeight: 600, marginBottom: '6px' }}>Kies datum:</div>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '10px' }}>
                {(v.datums || []).map(d => {
                  const dv = String(d).split('T')[0];
                  return <button key={dv} onClick={() => setKeuzeDatum(dv)}
                    style={{ background: keuzeDatum === dv ? '#059669' : '#fff', color: keuzeDatum === dv ? '#fff' : '#111827', border: '1px solid #059669', borderRadius: '8px', padding: '7px 12px', fontSize: '13px', fontWeight: 600, cursor: 'pointer' }}>{fmtD(dv)}</button>;
                })}
                {(!v.datums || !v.datums.length) && <span style={{ fontSize: '13px', color: '#dc2626' }}>Geen voorsteldatums — vraag de aanvrager om datums toe te voegen.</span>}
              </div>
              <div style={{ fontSize: '13px', fontWeight: 600, marginBottom: '4px' }}>Monteur(s):</div>
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '10px' }}>
                {monteurs.map(m => (
                  <label key={m.id} style={{ fontSize: '13px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <input type="checkbox" checked={keuzeMonteurs.includes(m.id)}
                      onChange={e => setKeuzeMonteurs(prev => e.target.checked ? [...prev, m.id] : prev.filter(x => x !== m.id))} />
                    {m.voornaam} {m.achternaam}
                  </label>
                ))}
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button onClick={geefAkkoord} disabled={busy}
                  style={{ background: '#059669', color: '#fff', border: 'none', borderRadius: '8px', padding: '9px 16px', fontWeight: 600, cursor: 'pointer' }}>{busy ? 'Bezig…' : '✅ Akkoord'}</button>
                <button onClick={() => setActief(null)}
                  style={{ background: '#f3f4f6', border: 'none', borderRadius: '8px', padding: '9px 16px', cursor: 'pointer' }}>Annuleren</button>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
